import { type FC, type ReactNode } from 'react';
import { Card } from '@mui/material';

interface CustomCardProps {
  id: string;
  variant?: 'outlined' | 'elevation';
  elevation?: number;
  className?: string;
  children?: ReactNode;
  height?: string;
}

const CustomCard: FC<CustomCardProps> = ({
  id,
  variant = 'elevation',
  elevation = 1,
  className,
  children,
  height
}) => {
  return (
    <Card
      id={id}
      variant={variant}
      elevation={variant === 'elevation' ? elevation : 0}
      className={className}
      sx={{ height: height }}
    >
      {children}
    </Card>
  );
};

export default CustomCard;
